export const environment = {
  firebase: {
    options: {
      projectId: 'fido-dabc6',
      appId: '1:716810271951:web:64dee0a475f3a6242e4bba',
      storageBucket: 'fido-dabc6.firebasestorage.app',
      apiKey: 'AIzaSyCOam4FdEzqIPZMxULaKUbpgNxqrxzCLzo',
      authDomain: 'fido-dabc6.firebaseapp.com',
      messagingSenderId: '716810271951',
      measurementId: 'G-6PY6CDF3EK',
      projectNumber: '716810271951',
      version: '2',
    },
    appCheck: {
      siteKey: '6LfJ4AQsAAAAABk4OHtqb807gHKG3BSsXcxvkKQk',
    },
  },
  fingerprintjs: {
    apiKey: 'W30PP3fNqToaKXVNL8VC',
  },
  intakeWidgetUrl: 'https://dev.inquiry.firmfirst.com',
};
